/* ==========================================================================
   CLARITY SCIENCE — HERO FIGURE COUNT-UP
   Counts a figure from 0 to its target once, when first scrolled into view.
   One rAF loop that ends itself: no scroll listener, no layout animation
   beyond the digit. Respects reduced-motion and works when a section is added
   in the Theme Editor. Progressive enhancement — the target renders without JS.
   ========================================================================== */
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function run(el, target) {
    var t0 = null, dur = 1800;
    /* easeOutExpo — quick off the mark, long settle. */
    var ease = function (x) { return x >= 1 ? 1 : 1 - Math.pow(2, -10 * x); };
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      el.textContent = Math.round(ease(p) * target);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target;
    };
    requestAnimationFrame(step);
  }

  function init(el) {
    if (!el || el.dataset.clarityCountBound === "1") return;
    el.dataset.clarityCountBound = "1";
    var target = parseInt(el.getAttribute("data-clarity-count"), 10) || 0;

    if (reduce) { el.textContent = target; return; }
    el.textContent = "0";

    if (!("IntersectionObserver" in window)) { run(el, target); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); run(el, target); }
      });
    }, { threshold: 0.4 });
    io.observe(el);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll("[data-clarity-count]"), init);
  }

  if (document.readyState !== "loading") scan(document);
  else document.addEventListener("DOMContentLoaded", function () { scan(document); });

  /* Theme Editor: initialise a hero added or re-rendered in the editor. */
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
})();
